
/**
 * Change log for the privacy notice in reverse chronological order,
 * meaning last update first
 */
export const privacyNoticeUpdates = [
  {
    date: '2018-05-24',
    notice: [
      `In order to comply with the General Data Protection Regulation (GDPR)
      we've established this privacy notice informing you of our practices
      regarding the protection of your personal data.`,
    ],
  },
];

export const privacyNoticeDate = privacyNoticeUpdates[0].date;



// WEBPACK FOOTER //
// ./src/config/privacy_changes.js